import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './lib/auth'
import { initPostHog } from './lib/posthog'
import App from './App'
import './index.css'

// Auto-update: reload when a new service worker takes control (triggered by
// visibility change so tab switches / home-screen reopens pick up new builds).
if ('serviceWorker' in navigator) {
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  navigator.serviceWorker.ready.then(registration => {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        registration.update();
      }
    });
  });
}

// Version-aware poll for desktop users who keep the tab open.
// Fetches deploy-info.json every 5 minutes; only reloads if deployedAt changed.
{
  let knownDeployedAt: string | null = null;
  const checkForUpdate = async () => {
    try {
      const res = await fetch('/deploy-info.json', { cache: 'no-store' });
      const data = await res.json();
      if (!data.deployedAt) return;
      if (knownDeployedAt === null) { knownDeployedAt = data.deployedAt; return; }
      if (data.deployedAt !== knownDeployedAt) window.location.reload();
    } catch { /* network error — ignore */ }
  };
  checkForUpdate();
  setInterval(checkForUpdate, 5 * 60_000);
}

initPostHog()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
